// chart.js v4 tidak mendaftarkan skala/controller di entry inti; pakai `auto`
// atau Chartkick gagal dengan: "linear" is not a registered scale.
import { Chart } from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Chartkick from 'chartkick'
import 'chartjs-adapter-date-fns'

const READY_FLAG = '__r6DashboardChartkickConfigured'

export function ensureChartkick() {
  if (typeof window !== 'undefined' && window[READY_FLAG] && window.Chartkick) {
    return window.Chartkick
  }

  Chart.register(ChartDataLabels)
  Chart.defaults.plugins.datalabels = {
    anchor: 'end',
    align: 'top',
    offset: -4,
    color: '#212529',
    font: { weight: '600', size: 11 },
    formatter: (value) => {
      const v = Number(value)
      return Number.isFinite(v) ? String(v) : ''
    },
  }

  Chartkick.use(Chart)

  if (typeof window !== 'undefined') {
    window.Chartkick = Chartkick
    window[READY_FLAG] = true
  }

  return Chartkick
}

ensureChartkick()
